module.exports = "<button md-menu-item>\n  <ng-content></ng-content>\n</button>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/toolbar/toolbar-menu-item/toolbar-menu-item.component.html
// module id = ../../../../../src/app/toolbar/toolbar-menu-item/toolbar-menu-item.component.html
// module chunks = 4